<template>
    <v-row
        align="center"
        justify="center">

        <v-col
            cols="12"
            sm="8"
            md="4">

            <v-card class="elevation-12" md5>
                <v-toolbar
                    color="primary"
                    dark
                    flat>
                    <v-toolbar-title>BiSecur Notifications - Login</v-toolbar-title>
                </v-toolbar>
                <v-alert :value="loginFailed"
                         transition="scale-transition"
                         color="error"
                         border="left"
                         dark tile>
                    Benutzername und Passwort stimmen nicht überein.
                </v-alert>

                <v-card-text>
                    <v-form>
                        <v-text-field
                            label="Login"
                            name="login"
                            v-model="username"
                            prepend-icon="mdi-account"
                            type="text"
                            autofocus
                        ></v-text-field>

                        <v-text-field
                            id="password"
                            label="Password"
                            name="password"
                            v-model="password"
                            prepend-icon="mdi-lock"
                            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                            @click:append="showPassword = !showPassword"
                            @keydown.enter="runLogin"
                            :type="showPassword ? 'text':'password'"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                           @click="runLogin"
                           :loading="isLoggingIn">Login
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "LoginView",
    data: () => ({
        username: null,
        password: null,
        showPassword: false,
        loginFailed: false,
    }),
    computed: {
        ...mapState('login', [
            'isLoggingIn'
        ]),
    },
    methods: {
        ...mapActions('login', [
            'login'
        ]),
        runLogin() {
            this.loginFailed = false;

            this.login({name: this.username, password: this.password}).then(success => {
                if (!success) {
                    this.loginFailed = true;
                }
            });
        }
    },
}
</script>

<style scoped>

</style>
